import { ApiResponse, ResponseModel } from '../../../../../common/interfaces';
import { RequestStatuses } from '../../../../../constants';
import { useQuery } from 'react-query';
import { ReactQueryKeys } from '../../../../../common/enums';
import { useFetch } from '../../../../../hooks/use-fetch/use-fetch';
import { leasingOfferRequestConfig } from '../../../../../request-config/leasing-offer/leasing-offer.request-config';
import { GetGlobalForDriverData } from '../../../../../request-config/leasing-offer/leasing-offer.types';
import { MassDataLeasingOffers, MassDataLeasingOffersResponse } from './use-mass-data-leasing-offers.types';

const modifyResponse = ({ data }: ApiResponse<MassDataLeasingOffersResponse>) => {
  if (data.level === RequestStatuses.Success) {
    return {
      count: data.data.count,
      items: data.data.leasingangebotes.map(leasingOffer => ({ id: leasingOffer.id, ...leasingOffer.attributes }))
    };
  }
  return { count: 0, items: [] };
};

const useMassDataLeasingOffers = (data: GetGlobalForDriverData) => {
  const { fetch } = useFetch<ResponseModel<MassDataLeasingOffersResponse>>({
    loadingKey: 'massDataLeasingOffers'
  });

  const { data: massDataLeasingOffers, isLoading: isMassDataLeasingOffersLoading } = useQuery<
    ApiResponse<MassDataLeasingOffersResponse>,
    unknown,
    MassDataLeasingOffers
  >(
    [ReactQueryKeys.GetMassDataLeasingOffers, data],
    () => fetch({ requestConfig: leasingOfferRequestConfig.getGlobalForDriver(data) }),
    {
      select: modifyResponse,
      enabled: !!data.search && !!data.uds_bezugid
    }
  );

  return {
    massDataLeasingOffers,
    isMassDataLeasingOffersLoading,
    massDataLeasingOffersIds: massDataLeasingOffers?.items.map(item => item.id) || []
  };
};

export default useMassDataLeasingOffers;
